<template>
  <div class="layout-container">
    <div class="sign_in2">
      <div class="sign_box2">
        <h2>登录</h2>
        <ul>
          <li>
            <label>
              <input
                v-model="loginForm.account"
                name="account"
                id="account"
                type="text"
                placeholder="用户名"
                autocomplete="off"
              />
            </label>
            <div class="clear"></div>
            <em>
              <font id="loginName_err"></font>
            </em>
          </li>
          <li>
            <label class="label1">
              <input
                v-model="loginForm.password"
                name="loginPwd"
                id="loginPwd"
                :type="inputType"
                placeholder="密码"
                :passwordshow="isShow"
                autocomplete="new-password"
              />
              <img class="img-eye" :src="passwordImg" @click="switchEye" />
            </label>
            <div class="clear"></div>
            <em>
              <font id="loginPwd_err"></font>
            </em>
          </li>
        </ul>
        <div class="a_sign2_box">
          <span>
            <a href="javascript:;" @click="userLogin" class="a_sign2" v-if="login">登 录</a>
            <a href="javascript:;" class="a_sign2" v-if="loading">登录中...</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入图片
import openEye from "../assets/images/openEye.png";
import closeEye from "../assets/images/closeEye.png";
// 登录接口
import { login } from "@/api/api";
// 加密方法
import { encryption } from '@/utils/utils.js'
export default {
  name: "Login",
  data() {
    return {
      openEye,
      closeEye,
      isShow: false, // 密码是否显示
      inputType: "password", // input的输入类型
      passwordImg: openEye,
      // 登录
      loginForm: {
        account: "",
        password: ""
      },
      // 登录的参数
      params: {},
      // 登录按钮的状态
      login: Boolean,
      loading: Boolean
    };
  },
  mounted() {
    this.login = true;
    this.loading = false;
  },
  methods: {
    switchEye() {
      // 修改密码的状态
      if (this.isShow) {
        this.isShow = false;
        this.inputType = "password";
        this.passwordImg = this.openEye;
      } else {
        this.isShow = true;
        this.inputType = "text";
        this.passwordImg = this.closeEye;
      }
    },
    userLogin() {
      // 登录
      this.login = false;
      this.loading = true;
      // 密码加密
      this.params = JSON.parse(JSON.stringify(this.loginForm));
      this.params.password = encryption(this.params.password);
      this.params.type = 0;
      this.params.reg_id = 'yonghetang';

      login(this.params)
        .then((res) => {
          console.log(res);
          // 存储token和user_id
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('user_id', res.data.user_id);
          // 跳转到首页
          this.$router.push({
            path: "/"
          });
          this.login = true;
          this.loading = false;
        })
        .catch((err) => {
          this.login = true;
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
/* 引入样式 */
@import "../styles/login.css";
</style>